import React from 'react';
import { MDXProvider } from '@mdx-js/react';

import Typography from '@material-ui/core/Typography';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    h1: {
      paddingBottom: '20px',
      padding: '0px 0px 10px 0px',
      color: '#0076bb',
      borderBottom: '2px solid #0076bb',
    },
    h2: {
      padding: '10px 0px 10px 0px',
      color: '#191a19',
    },
    h3: {
      color: '#191a19',
    },
  }),
);

type Props = { children: React.ReactNode; linkColor?: string; color?: string, borderColor?: string };

const MDXParser = (props: Props) => {
  const classes = useStyles();

  const color = props.color ? props.color : '#0076bb';
  const borderColor = props.borderColor ? props.borderColor : '#0076bb';

  const linkColor = props.linkColor ? props.linkColor : '#191a19';
  return (
    <MDXProvider
      components={{
        h1: (props: any) => (
          <Typography variant="h1" className={classes.h1} style={{ color: color, borderColor: borderColor }} {...props} />
        ),
        h2: (props: any) => (
          <Typography variant="h2" className={classes.h2} style={{ color: color }} {...props} />
        ),
        h3: (props: any) => (
          <Typography variant="h3" className={classes.h3} style={{ color: color }} {...props} />
        ),
        a: (props: any) => <a target="_blank" style={{ color: linkColor }} {...props} />,
      }}
    >
      {props.children}
    </MDXProvider>
  );
};

export default MDXParser;
